import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/privacy-policy/page.tsx");
